import { useEffect } from 'react';

import { Box, Col } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { IconAdjustmentsHorizontal, IconChevronLeft } from '@tabler/icons-react';
import { useNavMenu } from 'components/landing-pages-v2/shared/NavMenuContext';
import { MapLocationSearch } from 'components/marketplace/map/LocationSearch';
import type { LocationSearchProps } from 'components/marketplace/map/LocationSearch';

interface MobileHeaderFiltersProps extends Pick<
  LocationSearchProps,
  'selection' | 'onSelectionChange'
> {
  isFocused: boolean;
  onBack: () => void;
  onOpenFilters: () => void;
}

export const MobileHeaderFilters = ({
  isFocused,
  selection,
  onSelectionChange,
  onBack,
  onOpenFilters,
}: MobileHeaderFiltersProps) => {
  const { closeMenu } = useNavMenu();

  useEffect(() => {
    if (isFocused) {
      closeMenu();
    }
  }, [isFocused, closeMenu]);

  return (
    <Col className="relative">
      <MapLocationSearch
        selection={selection}
        onSelectionChange={onSelectionChange}
        isFocused={isFocused}
        size="xs"
      />
      <Box className="absolute right-2 top-1/2 z-[10000] -translate-y-1/2">
        <Button
          variant="secondary"
          aria-label="filter"
          analyticsName="cosmos-marketplace-map-header-filter-button"
          onClick={onOpenFilters}
          className="size-6 rounded-full border-0 bg-transparent p-0"
        >
          <IconAdjustmentsHorizontal size={20} />
        </Button>
      </Box>
      <Box
        className={`absolute left-2 top-1/2 z-[10000] -translate-y-1/2 ${
          isFocused ? 'flex' : 'hidden'
        }`}
      >
        <Button
          variant="secondary"
          aria-label="back"
          analyticsName="cosmos-marketplace-map-location-search-back-button"
          onClick={onBack}
          className="size-6 rounded-full border-0 bg-transparent p-0"
        >
          <IconChevronLeft size={20} />
        </Button>
      </Box>
    </Col>
  );
};
